import { AnonymousWidgetPos } from "../types";

export function getWidgetLeftValue(
  w: AnonymousWidgetPos | undefined,
  unitSize: number,
  spaceBetweenColumns: number
) {
  "worklet";
  if (w) {
    const { c, x } = w;
    return (c + 0.5) * spaceBetweenColumns + (c * 2 + x) * unitSize;
  }
  return 0;
}
